import React, { useContext, useEffect } from "react";
import CalendarContainer from "homepage/components/Calendar/CalendarContainer";
import TripList from "homepage/components/Trip/TripList";

import { CalendarInfoContext } from "shared/context/calendarInfo-context";
import { AuthContext } from "shared/context/auth-context";

const Homepage = () => {
  const auth = useContext(AuthContext);
  const calendarInfo = useContext(CalendarInfoContext);
  const { fetchTrips } = calendarInfo;

  useEffect(() => {
    if (auth.userId) {
      fetchTrips(auth.userId, auth.token);
    }
  }, [auth.userId, auth.token, fetchTrips]);

  if (!auth.token) {
    return (
      <div className="home-hero">
        <img className="coronaSign" src="corona-sign.jpg" alt="" />
        <iframe
          width="500"
          height="600"
          frameBorder="0"
          title="Weather"
          src="https://ambientweather.net/devices/public/adc736a12b8d62c110e0fb50d810e73a?embed=true"
        ></iframe>
        <p>
          Go To{" "}
          <a
            target="_blank"
            href="https://ambientweather.net/dashboard/adc736a12b8d62c110e0fb50d810e73a"
            rel="noreferrer noopener"
          >
            Mike's Weather App
          </a>
        </p>
        {/* <iframe
          className="weather"
          //src="https://www.weatherlink.com/embeddablePage/show/59376af68c1b4f2598c0734fa413ecbf/slim"

          src="https://ambientweather.net/dashboard/adc736a12b8d62c110e0fb50d810e73a"
          width="345"
          height="550"
          frameBorder="1"
          title="weather"
        ></iframe> */}
        {/* <iframe src='https://www.weatherlink.com/embeddablePage/show/59376af68c1b4f2598c0734fa413ecbf/wide' width='560' height='480' frameborder='0'></iframe>
        <iframe src='https://www.weatherlink.com/embeddablePage/show/59376af68c1b4f2598c0734fa413ecbf/slim' width='338' height='500' frameborder='0'></iframe>
         <iframe src='https://www.weatherlink.com/embeddablePage/show/59376af68c1b4f2598c0734fa413ecbf/signature' width='760' height='200' frameborder='0'></iframe>
          */}
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-6 pl-4">
          <CalendarContainer userId={auth.userId} className="homepage-center" />
        </div>
        <div className="col-xl-6 pl-4">
          <TripList />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
